module.exports = __webpack_public_path__ + "img/lazy.8fd66296.png";